const STOP = new Set(["ltd", "limited", "plc", "uk", "co", "the", "group", "llp", "inc"]);

export const normSupplier = (s) =>
  (s || "").toLowerCase().replace(/&/g, " and ").replace(/[^a-z0-9 ]+/g, " ")
    .split(/\s+/).filter((w) => w && !STOP.has(w)).join(" ");

const namesOf = (s) => [s.name, ...(s.aliases || [])].map(normSupplier).filter(Boolean);

const matches = (a, b) => a === b || (b.length >= 4 && a.startsWith(b + " ")) || (a.length >= 4 && b.startsWith(a + " "));

export function findSupplier(suppliers, name, type) {
  const n = normSupplier(name);
  if (!n) return null;
  return (suppliers || []).find((s) => s.active !== false && (s.types || []).includes(type)
    && namesOf(s).some((x) => matches(n, x))) || null;
}

export function isSupplierApproved(suppliers, name, type, category) {
  const s = findSupplier(suppliers, name, type);
  if (!s) return false;
  return !!(s.all_categories || (category && (s.categories || []).includes(category)));
}

export function approvedForCategory(suppliers, category) {
  const active = (suppliers || []).filter((s) => s.active !== false);
  const forCat = active.filter((s) => s.all_categories || (category && (s.categories || []).includes(category)));
  return {
    materials: forCat.filter((s) => (s.types || []).includes("materials")),
    access_hire: forCat.filter((s) => (s.types || []).includes("access_hire")),
  };
}

export const fillWarning = (tpl, supplier, category) =>
  (tpl || "").replace(/\{supplier\}/g, supplier || "This supplier").replace(/\{category\}/g, category || "this quote");

// Only suppliers approved for this category (or for all categories) are suggested.
export function supplierOptions(suppliers, type, category) {
  const ok = (s) => s.all_categories || (category && (s.categories || []).includes(category));
  return (suppliers || [])
    .filter((s) => s.active !== false && (s.types || []).includes(type) && ok(s))
    .map((s) => ({ name: s.name, label: s.all_categories ? "Approved for all categories" : "Approved" }));
}

// Older lines kept the supplier in product_name; newer ones use supplier_name + an item name.
export const lineSupplier = (li) => li.supplier_name || li.product_name || "";
export const lineItem = (li) => (li.supplier_name && li.product_name !== li.supplier_name ? li.product_name || "" : "");

export const itemMatchesSupplier = (li) =>
  !!(li.product_name && li.supplier_name && normSupplier(li.product_name) === normSupplier(li.supplier_name));
